import { Injectable } from '@angular/core';
import {map} from "rxjs/operators";
import {BackendService} from "../backend/backend.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TelecontactService {

  constructor(private http: HttpClient, private backendService: BackendService) { }



  public readAll(){
  }


  public getCol(col){
    return this.http.get('https://dashboardback1.herokuapp.com/companies/columnValues/'+col).pipe(map(d =>{
      return d['companies'].filter( v => v['_id'] !== null);
    }))
  }



  public numberByRegions(filters){
    return  this.http.post('https://dashboardback1.herokuapp.com/companies/groupCount', {
      filters: filters,
      groupBy: 'region'
    }).pipe(map(d => {
      let dd = d['companies'].sort((a, b) => {return b.count - a.count}).filter( v => v['_id'] !== null);
      let res =  {data: [dd.map(v => v['count'])], labels: dd.map(v => v['_id'])};
      return res;
    }));
  }


  public  numberByCities(filters){
    return  this.http.post('https://dashboardback1.herokuapp.com/companies/groupCount', {
      filters: filters,
      groupBy: 'city'
    }).pipe(map(d => {
      let dd = d['companies'].sort((a, b) => {return b.count - a.count}).filter( v => v['_id'] !== null );
      let res =  {data: [{data: dd.map(v => v['count']), label: 'city'}], labels: dd.map(v => v['_id'])};
      return res;
    }));
  }


  public numberByHr(filters) {
    return  this.http.post('https://dashboardback1.herokuapp.com/companies/groupCount', {
      filters: filters,
      groupBy: 'hr'
    }).pipe(map(d => {

      let dd = d['companies'].sort((a, b) => {return b.count - a.count}).filter( v => v['_id'] !== null && v['_id'] !== "NaN" && v['_id'] !== undefined);

      let su = 0;
      dd.map(d => su += d['count']);
      dd.map(d => parseFloat(((d['count'] / su)*100).toFixed(2)) );


      let res =  {data: [{data: dd.map(d => parseFloat(((d['count'] / su)*100).toFixed(2)) ), label: 'hr'}], labels: dd.map(v => v['_id'])};
      return res;
    }));
  }



  public numberByDate(filters){
    return  this.http.post('https://dashboardback1.herokuapp.com/companies/groupCount', {
      filters: filters,
      groupBy: 'founded_at'
    }).pipe(map(d => {

      let dd = JSON.parse(JSON.stringify(d['companies'])).filter( v => v['_id'] !== null && v['_id'] !== "NaN" && v['_id'] !== undefined && v['_id'] >= 1980 );

      let xs = dd.map(d => d['_id']).sort();

      for(let dt= Math.max(xs[0], 1980); dt < 2020; dt += 1){
        if(!xs.includes(dt) && typeof dt == 'string'){
          dd.push( {id_: dt, count: 0 } );
        }
      }


      dd = dd.sort( (a, b) => a['_id'] - b['_id'] );

      let r = 0;
      dd.map( d => {
        r += d['count'];
        d['count'] = r;
      });


      return  {data: [{data: dd.map(d => d['count']), label: ''}], labels: dd.map(d => d['_id'])};
    }));





  }



  public filter(dat, filters){
    let data = JSON.parse(JSON.stringify(dat));
    let res = [];
    for (let d of data){
      let one = Object.keys(d).map(k => d[k]).join('--').toLowerCase();
      let b = true;
      for(let f of filters ){
        b = b && one.includes( f.toLowerCase() );
      }
      if (b){
        res.push(d);
      }
    }
    return res;
  }


}
